import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import KeycloakService from '../../../services/KeycloakService';
import { updateApplicationStatus } from '../../../services/UserService';
import {
  SET_DATE_RANGE,
  SHOW_NOTIFICATION,
  WFHAttribute,
} from '../../../constants';
import GenericLoader from '../../../components/Loader/GenericLoader';
import { getProjectsByName } from '../../../services/ProjectService';
import PaginationComponent from '../../../components/Pagination/Pagination';
import { Box } from '@mui/system';
import { getHRLeavesRequests } from '../../services/LeaveService';
import LeaveStatusCardComponent from '../../../components/LeaveStatusCard/LeaveStatusCardComponent';
import { NO_LEAVE_REQUESTS } from '../../../pages/Manage/ManageConstants';
import { Grid, Typography } from '@mui/material';
import {
  setFilterConfig,
  setFilterDataState,
} from '../../../modules/filter/filterAction';
import GenericFilterDrawer from '../../../components/GenericFilter/GenericFilterDrawer';
import { checkFilterIconVisibility } from '../../../components/GenericFilter/FilterIconVisibilityCheck';
import { cardComponentCollapse } from '../../../modules/cardState/cardAction';
import { getLeaveTypeList } from '../../../services/LeaveService';
import moment from 'moment';
const ManageAllLeavesRequests = (props) => {
  const [leaveRequestList, setLeaveRequestList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [loader1, setLoader1] = useState(true);
  const [pageNo, setPageNo] = useState(0);
  const currentUserId = KeycloakService.getUserDetail();
  const [refreshPage, setRefreshPage] = useState(false);

  const [projectArray, setProjectArray] = useState([]);

  const [options, setOptions] = useState({});
  const [leaveTypeArray, setLeaveTypeArray] = useState([]);

  const filterState = useSelector((state) => state.filterState);

  const emptyFilterData = {
    employeeName: '',
    employeeId: '',
    leaveId: '',
    leaveName: '',
    status: '',
    startDate: '',
    endDate: '',
    projectName: '',
  };

  const [pageSize, setPageSize] = useState(5);
  const [totalPage, setTotalPage] = useState();
  const [page, setPage] = useState(1);

  const dispatch = useDispatch();
  const [showError, setShowError] = useState(false);

  const updateApplicationByHr = async (templateApplicationResponse) => {
    const updateApplicationStatusResponse = await updateApplicationStatus(
      templateApplicationResponse,
    );
    if (updateApplicationStatusResponse.isError === false) {
      setRefreshPage(!refreshPage);
    }
    dipatchNotification(
      updateApplicationStatusResponse.type,
      updateApplicationStatusResponse.message,
    );
    return updateApplicationStatusResponse;
  };

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const getProjects = async (pName) => {
    const projectList = await getProjectsByName(pName, 0, null);
    if (projectList?.status === 200) {
      setProjectArray((prevProjects) => [...projectList.data.content]);
      setOptions((prevOptions) => ({
        ...prevOptions,
        project: projectList.data.content,
      }));
    } else {
      setProjectArray((prevProjects) => []);
      setOptions((prevOptions) => ({ ...prevOptions, project: [] }));
    }
    setLoader(false);
  };

  const getLeaveNameAndCategoryId = (request, leaveTypes) => {
    const leaveTypeName = (leaveTypes || []).find(
      (item) => item.id === request?.leaveId,
    );
    request.leaveType = leaveTypeName?.leaveName;
    request.leaveCategoryId = leaveTypeName?.leaveCategoryId;
  };

  const ensureLeaveTypes = async () => {
    if (leaveTypeArray?.length) {
      return leaveTypeArray;
    }
    const year = new Date().getFullYear();
    const newData = await getLeaveTypeList(year);
    const leaveTypes = newData?.data || [];
    setLeaveTypeArray(leaveTypes);
    setOptions((prevOptions) => ({ ...prevOptions, leave: leaveTypes }));
    return leaveTypes;
  };

  const getLeavesRequests = async () => {
    const leaveTypes = await ensureLeaveTypes();
    const leavesRequests = await getHRLeavesRequests(
      currentUserId,
      filterState,
      pageSize,
      pageNo,
    );
    if (leavesRequests?.isError === false) {
      setTotalPage(leavesRequests.data.data.totalPages);
      leavesRequests.data.data.content.forEach((request) => {
        request.empName = `${request.empName}`;
        getLeaveNameAndCategoryId(request, leaveTypes);
      });
      setLeaveRequestList(leavesRequests.data.data.content);
      setLoader1(false);
      setLoader(false);
    }
    if (leavesRequests.status !== 200) {
      dipatchNotification(leavesRequests.type, leavesRequests.message);
    }
  };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setLoader(true);
    setRefreshPage(!refreshPage);
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
  };

  const filterConfiguration = {
    inputField: [
      [
        ['status', 'Leave Status'],
        [
          ['APPROVED', 'Approved'],
          ['PENDING', 'Pending'],
          ['REJECTED', 'Rejected'],
          ['CANCELLED', 'Cancelled'],
        ],
      ],
    ],
    autoComplete: [['Search Employee', 'employee']],
    dropdownField: [
      ['Search Project', 'project', 'projectName', 'id'],
      ['Leave', 'leave', 'leaveName', 'id'],
    ],
  };

  const applyDefaultDateRange = () => {
    if (filterState?.startDate && filterState?.endDate) {
      dispatch(setFilterConfig(filterConfiguration));
      return;
    }
    const endDate = moment().format('YYYY-MM-DD');
    const startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
    dispatch(setFilterConfig(filterConfiguration));
    dispatch({
      type: SET_DATE_RANGE,
      data: {
        startDate,
        endDate,
      },
    });
    dispatch(
      setFilterDataState({
        startDate,
        endDate,
      }),
    );
    dispatch(cardComponentCollapse());
  };

  const [resetFilter, setResetFilter] = useState(false);

  const getLeaveTypeData = async () => {
    await ensureLeaveTypes();
  };

  useEffect(() => {
    applyDefaultDateRange();
    getLeaveTypeData();
    getProjects();
    setResetFilter(true);
  }, []);

  const temp = useMemo(() => {
    pageChange(null, 1);
  }, [filterState]);

  useEffect(() => {
    if (resetFilter) getLeavesRequests();
  }, [refreshPage, resetFilter]);

  const getOptions = () => {
    return { ...options, project: projectArray };
  };

  return (
    <>
      {loader || loader1 ? (
        <div style={{ height: '80vh', overflow: 'hidden' }}>
          <GenericLoader
            rectAttributes={WFHAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <Box className="main-content-overlay">
          <div className="main-content-div">
            {checkFilterIconVisibility(
              filterState,
              emptyFilterData,
              leaveRequestList,
            ) && <GenericFilterDrawer options={getOptions()} />}
            <Box
              sx={{
                overflow: 'hidden',
              }}
            >
              {leaveRequestList.length != 0 ? (
                leaveRequestList.map((request, index) => {
                  return (
                    <LeaveStatusCardComponent
                      key={request.id}
                      leave={request}
                      leaveStatus={request.status}
                      updateApplicationByHr={updateApplicationByHr}
                    />
                  );
                })
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '80vh',
                  }}
                >
                  <div>
                    <Typography>{NO_LEAVE_REQUESTS}</Typography>
                  </div>
                </div>
              )}
            </Box>
            {leaveRequestList.length ? (
              <Box className="page-holder" sx={{ marginBottom: '7px' }}>
                <PaginationComponent
                  count={totalPage}
                  page={page}
                  pageChange={pageChange}
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                />
              </Box>
            ) : (
              <></>
            )}
          </div>
        </Box>
      )}
    </>
  );
};
export default ManageAllLeavesRequests;
